import { useState } from "react";
import { ChevronDown, ExternalLink, FileText } from "lucide-react";
import { toast } from "sonner";

// Daftar dokumen pada halaman "Pengelolaan Program dan Anggaran".
// Dokumen yang berkasnya sudah tersedia memakai `file` (path statik di /public),
// sehingga tetap dapat diakses baik di preview maupun produksi (tidak bergantung DB).
// Dokumen tanpa `file` akan menampilkan "Dokumen akan segera tersedia".
const DOCUMENTS = [
  {
    slug: "2024",
    label: "Laporan Keuangan tahun 2024 (audited)",
    file: "/laporan-keuangan-2024.pdf",
  },
  {
    slug: "2025",
    label: "Laporan Keuangan tahun 2025 (audited)",
    file: "/laporan-keuangan-2025.pdf",
  },
  { slug: "rka", label: "Rencana Kerja Anggaran (RKA)" },
  { slug: "dipa", label: "Daftar Isian Pelaksanaan Anggaran (DIPA)" },
  {
    slug: "realisasi",
    label: "Realisasi Anggaran Tahun Berjalan",
    url: "https://ppid-lldikti7.id/pengumuman",
  },
];

function DocItem({ slug, label, file, url }) {
  const [open, setOpen] = useState(false);
  const href = file || url;

  return (
    <div
      data-testid={`laporan-keuangan-item-${slug}`}
      className="overflow-hidden rounded-2xl border border-[#BBDCF3] bg-white"
    >
      <button
        type="button"
        data-testid={`laporan-keuangan-toggle-${slug}`}
        aria-expanded={open}
        onClick={() => setOpen((v) => !v)}
        className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left transition-colors hover:bg-[#F4FAFE]"
      >
        <span className="flex items-center gap-3">
          <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-[#EFF6FC]">
            <FileText aria-hidden="true" className="h-5 w-5 text-[#1479BF]" />
          </span>
          <span className="font-display text-base font-semibold md:text-lg">
            {label}
          </span>
        </span>
        <ChevronDown
          aria-hidden="true"
          className={`h-5 w-5 shrink-0 text-[#1479BF] transition-transform duration-300 ${
            open ? "rotate-180" : ""
          }`}
        />
      </button>

      {open && (
        <div
          data-testid={`laporan-keuangan-body-${slug}`}
          className="border-t border-[#E3F0FA] bg-[#FBFDFF] px-5 py-4"
        >
          {href ? (
            <a
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`laporan-keuangan-link-${slug}`}
              className="inline-flex items-center gap-2 rounded-full bg-[#1479BF] px-4 py-2 text-sm font-semibold text-white transition-colors hover:bg-[#0B5E99]"
            >
              Lihat Laporan
              <ExternalLink aria-hidden="true" className="h-4 w-4" />
            </a>
          ) : (
            <button
              type="button"
              data-testid={`laporan-keuangan-link-${slug}`}
              onClick={() => toast.info("Dokumen akan segera tersedia")}
              className="inline-flex items-center gap-2 rounded-full bg-[#1479BF] px-4 py-2 text-sm font-semibold text-white transition-colors hover:bg-[#0B5E99]"
            >
              Lihat Laporan
              <ExternalLink aria-hidden="true" className="h-4 w-4" />
            </button>
          )}
        </div>
      )}
    </div>
  );
}

export default function LaporanKeuanganSection() {
  return (
    <div data-testid="laporan-keuangan-section" className="mt-10 space-y-3">
      {DOCUMENTS.map(({ slug, label, file, url }) => (
        <DocItem key={slug} slug={slug} label={label} file={file} url={url} />
      ))}
    </div>
  );
}
